<template>
  <div v-auto-animate :class="cn('flex items-baseline justify-between', props.class)">
    <!-- Expand -->
    <UiButton
      class="text-primary -mx-4 flex h-fit w-auto items-center justify-center gap-1 font-medium"
      variant="ghost"
      @click="handleExpand"
    >
      <ChevronLeft
        class="size-4 transition-transform duration-200 data-[expanded=true]:-rotate-90 ltr:data-[expanded=true]:rotate-90"
        :data-expanded="expanded"
      />
      {{ t("expand_title") }}
    </UiButton>

    <PensionPortfolioDebug />
  </div>

  <UiExpandTransition>
    <div ref="expandedContent">
      <slot v-if="expanded" />
    </div>
  </UiExpandTransition>
</template>

<script setup lang="ts">
import { ChevronLeft } from "lucide-vue-next"

const props = defineProps<{
  class?: ClassValue
}>()

const { scrollTo } = useScrollUtils()

const expanded = ref(false)
const expandedContent = ref<HTMLElement | null>(null)

const handleExpand = () => {
  expanded.value = !expanded.value
  if (expandedContent.value) {
    scrollTo(expandedContent.value)
  }
}

const { t } = useI18n({ useScope: "local" })
</script>

<i18n lang="json">
{
  "he": {
    "expand_title": "לפירוט התיק המלא שלך"
  },
  "en": {
    "expand_title": "Full portfolio"
  }
}
</i18n>
